import { createContext, useContext, useEffect, useState } from 'react';
import { Roadmap } from './types';
import { roadmapsApi } from './api';
import { useParams } from 'react-router-dom';

interface RoadmapContextType {
    roadmap: Roadmap | null;
    isLoading: boolean;
    error: Error | null;
}

const RoadmapContext = createContext<RoadmapContextType | undefined>(undefined);

export function RoadmapProvider({ children }: { children: React.ReactNode }) {
    const { roadmapId } = useParams<{ roadmapId: string }>();
    const [roadmap, setRoadmap] = useState<Roadmap | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        if (!roadmapId) {
            setIsLoading(false);
            return;
        }

        const fetchRoadmap = async () => {
            setIsLoading(true);
            const { data, error } = await roadmapsApi.get(roadmapId);
            if (error) setError(error);
            else setRoadmap(data);
            setIsLoading(false);
        };

        fetchRoadmap();
    }, [roadmapId]);

    return (
        <RoadmapContext.Provider value={{ roadmap, isLoading, error }}>
            {children}
        </RoadmapContext.Provider>
    );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useRoadmap() {
    const context = useContext(RoadmapContext);
    if (context === undefined) {
        throw new Error('useRoadmap must be used within a RoadmapProvider');
    }
    return context;
}
